export default "__VITE_ASSET__79a53bcb__"